import React, { useState, useEffect, useRef } from "react";
import './Header.css';
import { MdAccountCircle, MdFavorite, MdShoppingCart } from "react-icons/md";
import Loginform from "./Loginform";
import { toast } from "react-toastify";
import Viewcartitem from "../../Screens/Viewcartitem";
import { useSelector } from "react-redux";

const SocialMedia = ({ getCooki }) => {
    const [toggleLogin, setToggleLogin] = useState(false);
    const cartItems = useSelector(state => state.Reducer)
    const [opencart, setOpencart] = useState(false);
    const lengthItem = cartItems.length

    // Refs for detecting clicks outside
    const loginRef = useRef(null);
    const cartRef = useRef(null);

    // Close the login container or cart container on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Close login container if clicked outside
            if (loginRef.current && !loginRef.current.contains(event.target)) {
                setToggleLogin(false);
            }

            // Close cart container if clicked outside
            if (cartRef.current && !cartRef.current.contains(event.target)) {
                setOpencart(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>

            <div className="social-media">
                <ul className="social-media-desktop">
                    <li>
                        <div>
                            <MdAccountCircle
                                className="my-account"
                                onClick={() => setToggleLogin(!toggleLogin)}
                            />
                            <span style={{ position: "relative" }} ref={loginRef}>
                                <h6 id="accountname"> </h6>
                                <h6 className="accountnamedisplay" id="accountnamedisplay">
                                    {getCooki ? getCooki(window.accountname) : "Guest"}
                                </h6>
                                <span
                                    className="login-container"
                                    style={{ display: toggleLogin ? "flex" : "none" }}
                                >
                                    <Loginform setToggleLogin={setToggleLogin} />
                                </span>
                            </span>
                        </div>
                    </li>
                    <li>
                        <span className="my-favorite">
                            <MdFavorite className="your-favorite" />
                            <span className="batch1">0</span>
                        </span>
                    </li>
                    <li>
                        <div>
                            <span className="my-cart">
                                <MdShoppingCart
                                    className="your-cart"
                                    onClick={() => {
                                        if (lengthItem === 0) {
                                            setOpencart(false);
                                            toast.warn("Your Cart Is Empty!", {
                                                position: "top-center",
                                                autoClose: 2000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: true,
                                            });
                                        } else {
                                            setOpencart(!opencart);
                                        }
                                    }}
                                />
                                <span className="batch2">{lengthItem}</span>
                            </span>
                            <span style={{ position: "relative" }} ref={cartRef}>
                                <span
                                    className="viewcart_container"
                                    style={{ display: opencart ? "flex" : "none" }}
                                >
                                    <Viewcartitem />
                                </span>
                            </span>
                        </div>
                    </li>
                </ul>
            </div>

        </>

    );
};

export default SocialMedia;
